export default __webpack_public_path__ + "static/media/Rupee.ee9ebc39.svg";